import { useListView } from '../../core/ListViewProvider'
import { DownloadAsoListGrouping } from './DownloadAsoListGrouping'
import { DownloadAsoListSearchComponent } from './DownloadAsoListSearchComponent'

export const DownloadAsoListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <DownloadAsoListSearchComponent
        actions={selected.length > 0 ? <DownloadAsoListGrouping /> : undefined}
      />
    </div>
  )
}
